<section class="vl-u-spacer--large">
  <anb-tabs-deprecated>
    <anb-tab-deprecated tabTitle="{{ 'OVERZICHT.AANVRAGEN.LOPENDE_AANVRAGEN' | translate }}">
      <ng-container [ngTemplateOutlet]="aanvraagTable" [ngTemplateOutletContext]="{ aanvragen: lopendeAanvragen }"> </ng-container>
    </anb-tab-deprecated>
    <anb-tab-deprecated tabTitle="{{ 'OVERZICHT.AANVRAGEN.INGEDIENDE_AANVRAGEN' | translate }}">
      <ng-container [ngTemplateOutlet]="aanvraagTable" [ngTemplateOutletContext]="{ aanvragen: ingediendeAanvragen }"> </ng-container>
    </anb-tab-deprecated>
    <anb-tab-deprecated tabTitle="{{ 'OVERZICHT.AANVRAGEN.AFGEHANDELDE_AANVRAGEN' | translate }}">
      <ng-container [ngTemplateOutlet]="aanvraagTable" [ngTemplateOutletContext]="{ aanvragen: afgehandeldeAanvragen }"> </ng-container>
    </anb-tab-deprecated>
  </anb-tabs-deprecated>
</section>

<ng-template #aanvraagTable let-aanvragen="aanvragen">
  <table class="vl-data-table vl-data-table--hover">
    <thead>
      <tr>
        <th class="col-ref">{{ 'OVERZICHT.AANVRAGEN.REFERENTIENUMMER' | translate }}</th>
        <th class="col-date">{{ 'OVERZICHT.AANVRAGEN.LAATST_GEWIJZIGD' | translate }}</th>
        <th class="col-title">{{ 'OVERZICHT.AANVRAGEN.TITEL' | translate }}</th>
        <th class="col-action"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let aanvraag of aanvragen">
        <td>{{ aanvraag.referentieNummer }}</td>
        <td>{{ aanvraag.updatedAt | date: 'dd/MM/yyyy' }}</td>
        <td>{{ aanvraag.titel }}</td>
        <td>
          <div class="actions">
            <div (click)="openDetail(aanvraag.id)">
              <p class="vl-icon-wrapper" *ngIf="aanvraag.status === status.AanvraagAfwerken">
                <span class="vl-link"> {{ 'OVERZICHT.AANVRAGEN.BEWERKEN' | translate }}</span>
              </p>
              <p class="vl-icon-wrapper" *ngIf="aanvraag.status === status.Ingediend">
                <span class="vl-link"> {{ 'OVERZICHT.AANVRAGEN.CONSULTEREN' | translate }}</span>
              </p>
            </div>
            <div *ngIf="canDelete(aanvraag)">|</div>
            <div *ngIf="canDelete(aanvraag)" (click)="deleteAanvraag(aanvraag.id)">
              <p class="vl-icon-wrapper">
                <span class="vl-icon vl-icon--before vl-vi vl-vi-trash vl-link no-underline" aria-hidden="true"></span>
                <span class="vl-link"> {{ 'OVERZICHT.AANVRAGEN.DELETE' | translate }}</span>
              </p>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>
